// Make mobile menu items clickable
document.querySelectorAll('.mobile-menu-container a[data-no-instant]:not([data-nav-title])').forEach(link => {
  link.addEventListener('click', function (e) {
    e.preventDefault();

    const arrow = this.querySelector('.icon-down-arrow');
    if (arrow) {
      arrow.click(); // trigger same behavior
    }
  });
});

// Collection List Slider
document.addEventListener('DOMContentLoaded', function () {
  const sliders = document.querySelectorAll('.collection-list--slider');
  if (!sliders.length) return;

  const instances = new Map();
  let isMobile = null;

  function itemsPerDesktop(slider) {
    const n = parseInt(slider.dataset.sliderItemsDesktop, 10);
    return Number.isFinite(n) && n > 0 ? n : 5;
  }

  function itemsPerMobile(slider) {
    const n = parseInt(slider.dataset.sliderItemsMobile, 10);
    return Number.isFinite(n) && n > 0 ? n : 6;
  }

  function groupItems(slider) {
    if (slider.classList.contains('is-grouped')) return;

    const items = Array.from(slider.querySelectorAll('.carousel-cell'));
    const perSlide = itemsPerMobile(slider);

    const groups = [];
    for (let i = 0; i < items.length; i += perSlide) {
      const group = document.createElement('div');
      group.className = 'carousel-group';

      items.slice(i, i + perSlide).forEach(el => group.appendChild(el));
      groups.push(group);
    }

    slider.innerHTML = '';
    groups.forEach(group => slider.appendChild(group));

    slider.classList.add('is-grouped');
  }

  function ungroupItems(slider) {
    if (!slider.classList.contains('is-grouped')) return;

    const groups = Array.from(slider.querySelectorAll('.carousel-group'));
    const items = [];

    groups.forEach(group => {
      items.push(...Array.from(group.children));
    });

    slider.innerHTML = '';
    items.forEach(item => slider.appendChild(item));

    slider.classList.remove('is-grouped');
  }

  function initDesktop(slider) {
    if (instances.has(slider)) return;

    const flkty = new Flickity(slider, {
      cellSelector: '.carousel-cell', // 👈 normal behavior
      imagesLoaded: true,
      cellAlign: 'left',
      groupCells: itemsPerDesktop(slider),
      contain: true,
      wrapAround: true,
      prevNextButtons: false
    });

    instances.set(slider, flkty);
  }

  function initMobile(slider) {
    if (instances.has(slider)) return;

    groupItems(slider);

    const flkty = new Flickity(slider, {
      cellSelector: '.carousel-group', // 👈 grouped slides
      cellAlign: 'left',
      contain: true,
      wrapAround: true,
      prevNextButtons: false,
      pageDots: true
    });

    instances.set(slider, flkty);
  }

  function destroy(slider) {
    const flkty = instances.get(slider);
    if (!flkty) return;

    flkty.destroy();
    instances.delete(slider);

    ungroupItems(slider);
  }

  function handleResize() {
    const mobile = window.matchMedia('(max-width: 768px)').matches;

    if (mobile === isMobile) return;
    isMobile = mobile;

    sliders.forEach(slider => {
      destroy(slider);

      if (mobile) {
        initMobile(slider);
      } else {
        initDesktop(slider);
      }
    });
  }

  handleResize();
  window.addEventListener('resize', handleResize);
});


// Video Autoplay mobile
/*
|--------------------------------------------------------------------------
| Mobile Video Only
|--------------------------------------------------------------------------
| This file ONLY handles:
| .plyr__video-embed[data-mobile-video]
|
| Desktop continues using the original theme JS untouched.
|--------------------------------------------------------------------------
*/

window.videoMobile = {

  init() {

    if (!window.matchMedia('(max-width: 798px)').matches) return;

    this.forceSafariAutoplay();
    this.initPlyr();
  },

  /*
  |--------------------------------------------------------------------------
  | STEP 1: FORCE VIMEO/YOUTUBE AUTOPLAY VIA IFRAME (SAFARI SAFE)
  |--------------------------------------------------------------------------
  */

  forceSafariAutoplay() {

    $('[data-mobile-video]').each(function() {

      const $iframe = $(this).find('iframe');

      if (!$iframe.length) return;

      try {

        const src = new URL($iframe.attr('src'));

        // CRITICAL FOR SAFARI
        src.searchParams.set('autoplay', '1');
        src.searchParams.set('muted', '1');
        src.searchParams.set('playsinline', '1');
        src.searchParams.set('background', '1');
        src.searchParams.set('loop', '1');

        $iframe.attr('src', src.toString());

      } catch (e) {
        console.warn('Safari iframe autoplay failed', e);
      }
    });
  },

  /*
  |--------------------------------------------------------------------------
  | STEP 2: INIT PLYR + PLAY CONTROL RETRY
  |--------------------------------------------------------------------------
  */

  initPlyr() {

    const videos = $('[data-mobile-video]').get();

    if (!videos.length) return;

    const players = Plyr.setup(videos, {
      controls: window.videoControls,
      muted: true,
      autoplay: true,
      storage: { enabled: false }
    });

    players.forEach(player => {

      const $wrapper = $(player.elements.container);
      const $image = $wrapper.find('.video-wrapper__image');
      const $video = $wrapper.find('[data-video-element]');

      // click poster
      $image.on('click', () => {
        $image.hide();
        $video.show();
        player.play();
      });

      // SAFARI RELIABLE AUTOPLAY RETRY (ONLY PLAY, NO RELOAD)
      let attempts = 0;

      const tryPlay = () => {

        player.muted = true;

        player.play().catch(() => {

          attempts++;

          if (attempts < 8) {
            setTimeout(tryPlay, 800);
          }
        });
      };

      setTimeout(tryPlay, 300);
    });
  }
};

document.addEventListener('DOMContentLoaded', () => {
  window.videoMobile?.init();
});